import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    /** 获取商品列表 **/
    GET_LIST(data) {
        controller='EsGoods';
        action='GetList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取商品列表 **/
    GET_COLLECT_GOODS(data) {
        controller='EsGoods';
        action='GetCollectGoods';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 获取商品评论列表 **/
    GET_COMMENT_LIST(data) {
        controller='EsGoods';
        action='GetGoodsCommentList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 获取商品详情 **/
    GET_GOODS_INFO(data) {
        controller='EsGoods';
        action='GetGoodsInfo';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取编辑的商品信息 **/
    GET_GOODS_INFO_LIST(data) {
        controller='EsGoods';
        action='GetGoodsInfodata';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取商品数据类型 **/
    GET_GOODS_TYPES(data) {
        controller='EsGoods';
        action='GetGoodsType';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    }, 
    
    /** 获取成色数据类型 **/
    GET_GOODS_FINENESS(data) {
        controller='EsGoods';
        action='GeFineness';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },  

    /** 获取上下架数据类型 **/
    GET_GOODS_UNSER_LINE(data) {
        controller='EsGoods';
        action='GetGoodsUnderLines';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },  

    /** 新增商品 **/
    ADD_GOODS(data) {
        controller='EsGoods';
        action='AddGoods';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },  

    /** 编辑商品 **/
    SAVE_GOODS(data) {
        controller='EsGoods';
        action='EditGoods';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },  

    /** 删除商品信息 **/
    DEL_GOODS(data) {
        controller='EsGoods';
        action='DelGoods';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取冻结记录 **/
    GET_FROZEN_LOG(data) {
        controller='EsGoods';
        action='GetGoodsFrozen';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取未处理冻结记录数量 **/
    GET_FROZEN_COUNT(data) {
        controller='EsGoods';
        action='GetFrozenCount';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取冻结记录详情 **/
    GET_FROZEN_LOG_DETAIL(data) {
        controller='EsGoods';
        action='GetGoodsFrozenDetail';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 忽略投诉信息 **/
    FROZEN_IGNORE(data) {
        controller='EsGoods';
        action='FrozenIgnore';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 冻结商品信息 **/
    FROZEN_GOODS(data) {
        controller='EsGoods';
        action='FrozenGoods';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取冻结记录详情 **/
    FROZEN_GOODS_DETAIL(data) {
        controller='EsGoods';
        action='GetFrozenDetail';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取交易方式 **/
    GET_SHIPPING_LIST(data) {
        controller='EsGoods';
        action='GetShippingTypes';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取交易方式 **/
    GET_CITY_LIST(data) {
        controller='EsGoods';
        action='GetCityList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取评论信息列表 **/
    GET_GOODS_COMMENT(data) {
        controller='EsGoods';
        action='GetCommentList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 删除评论 **/
    DEL_COMMENT(data) {
        controller='EsGoods';
        action='DelComment';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取私信信息列表 **/
    GET_LETTER_LIST(data) {
        controller='EsGoods';
        action='GetLetterList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 删除私信内容 **/
    DEL_LETTER(data) {
        controller='EsGoods';
        action='DelLetter';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 修改商品置顶时间 **/
    EDIT_GOODS_TOP(data) {
        controller='EsGoods';
        action='EditGoodsTop';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

}